// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:25:09

export default {
  "id": "tatto-master",
  "slug": "tatto-master",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/19ef476755364bddb9d207d187359256-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/19ef476755364bddb9d207d187359256/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Tattoo Master",
      "description": "Try your hand at being a tattoo artist. Give your customers beautiful and crazy tattoos! Сhoose different styles and use different colors! And the most important - enjoy the gameplay experience.",
      "instructions": "Use various gameplay mechanics to complete the level and get more difficult orders. Feel like a salon manager, draw and complete more and more complex drawings.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "10x10"
      ]
    },
    "zh-CN": {
      "title": "纹身大师",
      "description": "尝试成为一名纹身艺术家。为您的顾客创作美丽而独特的纹身！选择不同的风格并使用各种颜色！最重要的是——享受游戏体验。",
      "instructions": "利用各种游戏玩法机制完成关卡，获取更难的指令。体验沙龙经理的感觉，绘制并完成越来越复杂的图案。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "10x10"
      ]
    },
    "zh-TW": {
      "title": "刺青大師",
      "description": "試試手氣，成為一名刺青藝術家。為您的客戶設計美麗又狂野的刺青！選擇不同的風格和使用各種顏色！最重要的是——享受遊戲體驗。",
      "instructions": "利用多種遊戲機制來通關等級並獲取更困難的任務。體驗如沙龙經理，繪製並完成越來越複雜的圖畫。",
      "genres": [
        "打扮"
      ],
      "tags": [
        "10x10"
      ]
    },
    "zh-HK": {
      "title": "刺青大師",
      "description": "試試手氣成為刺青藝術家。為客戶提供美麗而狂野的刺青！選擇不同的風格和使用不同的顏色！最重要的是——享受遊戲體驗。",
      "instructions": "使用各種遊戲機制完成關卡，並獲得更困難的任務。感受美髮院經理的滋味，繪製並完成越來越複雜的圖案。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "10x10"
      ]
    },
    "ja": {
      "title": "タトゥー・マスター",
      "description": "タトゥーアーティストとしての腕前を試してみてください。お客様に美しくクレージーなタトゥーを提供しましょう！さまざまなスタイルを選び、異なる色を使ってください！そしてもっとも大切なのは、ゲームプレイの体験を楽しむことです。",
      "instructions": "さまざまなゲームメカニクスを使ってレベルをクリアし、より難しい命令を獲得しましょう。サロンマネージャーとして感じながら、どんどん複雑化する絵を描き、完成させましょう。",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "10x10（10×10）"
      ]
    },
    "ko": {
      "title": "문신 마스터",
      "description": "타투 아티스트가 되어보세요. 고객들에게 아름다운 그리고 독특한 타투를 제공하세요! 다양한 스타일과 다양한 색상을 선택하세요! 그리고 가장 중요한 것은 게임 플레이 경험을 즐기세요!",
      "instructions": "다양한 게임 메커니즘을 사용하여 레벨을 완료하고 더 어려운 명령을 받아보세요.沙龙 매니저로 느껴보며, 점점 더 복잡한 그림을 그려 완료하세요.",
      "genres": [
        "드레스업"
      ],
      "tags": [
        "10x10"
      ]
    },
    "fr": {
      "title": "Maître du Tatouage",
      "description": "Essayez votre main comme tatoueur. Offrez à vos clients des tatouages beaux et follement originaux ! Choisissez différents styles et utilisez différentes couleurs ! Et le plus important - profitez de l'expérience de jeu.",
      "instructions": "Utilisez diverses mécaniques de jeu pour terminer le niveau et obtenir des ordres de plus en plus difficiles. Ressemblez-vous à un gestionnaire de salon, dessinez et terminez de plus en plus de dessins complexes.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "10x10"
      ]
    }
  }
};
